import { useGate, useStore } from 'effector-react'
import { refuelingModel } from '~/features/Refueling'
import { Button } from '~/shared/ui/Buttons'
import { PageContainer } from '~/shared/ui/PageContainer'

export function RefuelingPage() {
  useGate(refuelingModel.Gate)

  const widgetUrl = useStore(refuelingModel.$widgetUrl)
  const isLoading = useStore(refuelingModel.getWidgetUrlFx.pending)

  return (
    <PageContainer canBack backTitle='Заправка' title='Заправка'>
      <Button
        href={widgetUrl || ''}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        target='_blank'
        fullWidth
        //variant='primary'
        size='large'
        loading={isLoading}
        disabled={!widgetUrl}
      >
        Заправиться
      </Button>
    </PageContainer>
  )
}
